import { req, Request } from '../Repository';
import { setFullToken, checkTokenHeaders } from '../apiHelper';

const resource = '/xdent/locations';

export default {
    getLocationById: async (id, token = JSON.parse(localStorage.getItem('token'))) => {
        let { data } = await req(token).then((token) => {
            return Request.get(`${resource}/${id}`, token);
        });
        return data;
    },
    getAllLocations: (token) => {
        return req(token).then((token) => {
            return Request.get(`${resource}/getlocationoverviewbyuser`, token);
        });
    },
    //LOGO
    getLocactionLogoByLocationLogoId: (id, token) => {
        return req(token).then((token) => {
            return Request.get(`xdent/file/getlogocontentbylogoid?logoId=${id}&imageType=2`, token);
        });
    },
};
